<template>
    <Dialog class="template-modal" :hiddenTitle="true" :showFooter="false" :mask="true" :forceCenter="true">
        <div class="close-icon" @click="closeModal">
            <img :src="require('@/public/img/task/close.svg')" alt="" />
        </div>

        <div class="template-content">
            <div class="left-menu" :style="{ backgroundImage: `url(${require('@/app/assets/img/templateModal/title-bg.png')})` }">
                <div class="title-box">
                    <img :src="require(`@/app/assets/img/templateModal/title.svg`)" alt="" />
                    <p>{{ $t("title") }}</p>
                </div>

                <ScrollView ref="menuList" class="leftmenu-list">
                    <div>
                        <div class="tab-list">
                            <div
                                class="tab-item"
                                :class="{ active: activeTabId == item.id }"
                                v-for="item in tabList"
                                :key="item.id"
                                @click="clickTab(item.id)"
                            >
                                <iconSymbol :name="`moretemplate-${item.label}`" />
                                <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                            </div>
                        </div>

                        <div class="leftmenu-item" v-for="item in menuList" :key="item.info.id">
                            <div class="leftmenu-item-head" :class="{ active: activeMenuId == item.info.id }" @click="clickMenu(item)">
                                <iconSymbol :name="`moretemplate-${item.info.name}`" />
                                <p :title="lang == 'en' ? item.info.name : item.info['name_' + lang]">
                                    {{ lang == "en" ? item.info.name : item.info["name_" + lang] }}
                                </p>
                                <img
                                    class="leftmenu-arrow"
                                    :src="
                                        require(
                                            `@/app/assets/img/templateModal/arrow-${
                                                activeMenuId == item.info.id || expandMenuId == item.info.id ? 'down' : 'right'
                                            }.svg`
                                        )
                                    "
                                    alt=""
                                />
                            </div>

                            <collapseTransition>
                                <div class="leftmenu-item-childlist" v-show="expandMenuId == item.info.id">
                                    <div
                                        class="leftmenu-item-child"
                                        :class="{ active: activeMenuChildId == child.info.id }"
                                        v-for="child in item.lv2"
                                        :key="child.info.id"
                                        @click="clickLv2(child)"
                                    >
                                        <p :title="lang == 'en' ? child.info.name : child.info['name_' + lang]">
                                            {{ lang == "en" ? child.info.name : child.info["name_" + lang] }}
                                        </p>
                                    </div>
                                </div>
                            </collapseTransition>
                        </div>
                    </div>
                </ScrollView>

                <div class="checkbox-box">
                    <Checkbox class="echartSet_checkbox" v-model="autoOpen" @on-change="setOpenStatus" :title="$t('autoOpen')">
                        {{ $t("autoOpen") }}
                    </Checkbox>
                </div>
            </div>

            <div class="right-box">
                <div class="topbar">
                    <div>
                        <Input
                            class="title-search"
                            v-model="searchValue"
                            :placeholder="$t('search')"
                            clearable
                            :data-locate="'new-search'"
                            :maxlength="50"
                            @on-enter="search()"
                            @on-clear="backFromSearch"
                        >
                            <img
                                :src="require('@/home/assets/img/newPage/recommend/search.svg')"
                                alt=""
                                slot="prefix"
                                class="search-inputicon"
                                :data-locate="'new-search-btn'"
                            />
                        </Input>
                    </div>
                </div>

                <div class="right-box-emptyview" v-show="showEmptyView">
                    <img src="@/app/assets/img/templateModal/null.svg" alt="" />
                    <p>{{ $t(emptyViewText) }}</p>
                </div>

                <div class="right-box-topbar" v-if="!showEmptyView && !searchMode && activeTabId != -1">
                    <p class="right-box-title">{{ $t(activeTab) }}</p>
                    <div v-show="[0, 3].includes(activeTabId)" class="right-box-btn" @click="toTemplates">
                        <p>{{ $t("toStore") }}</p>
                        <img :src="require(`@/app/assets/img/templateModal/toStore.svg`)" alt="" />
                    </div>
                </div>

                <ScrollView
                    ref="rightList"
                    v-show="!showEmptyView"
                    class="right-box-list"
                    :class="{ 'right-box-template-list': showLv2List || showLv2Full || searchMode }"
                >
                    <div>
                        <template v-if="searchMode">
                            <div class="right-box-search">
                                <div class="right-box-back" @click="backFromSearch">
                                    <img class="leftmenu-arrow" src="@/app/assets/img/templateModal/arrow-right.svg" alt="" />
                                    <p>{{ $t("back") }}</p>
                                </div>
                                <div class="right-box-tem">
                                    <div class="right-box-item" v-for="item in searchList" :key="item.id" @click="useSearchTem(item)">
                                        <div class="right-box-item-imgbox">
                                            <img v-lazy="item.img_url" alt="" />
                                        </div>
                                        <div class="right-box-item-text">
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <div class="right-box-item-tag" v-if="item.type === 'mfree'">
                                            <span>{{ $t(vipTag) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="right-box-recommond" v-show="activeTabId == 0">
                                <div class="right-box-tem">
                                    <div class="right-box-item" v-for="item in recommendTempList" :key="item.id" @click="useRecommendTem(item)">
                                        <div class="right-box-item-imgbox">
                                            <img v-lazy="item.pre_img_url" alt="" />
                                        </div>
                                        <div class="right-box-item-text">
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <div class="right-box-item-tag" v-if="item.type === 'mfree'">
                                            <span>{{ $t(vipTag) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="right-box-recent" v-show="activeTabId == 1">
                                <div class="right-box-tem">
                                    <div class="right-box-item" v-for="item in recentData" :key="item.id" @click="useRecentTem(item)">
                                        <div class="right-box-item-imgbox">
                                            <img v-lazy="item.pre_img_url || item.img_url" alt="" />
                                        </div>
                                        <div class="right-box-item-text">
                                            <p>{{ item.title || item.name }}</p>
                                        </div>
                                        <div class="right-box-item-tag" v-if="item.type === 'mfree'">
                                            <span>{{ $t(vipTag) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="right-box-personal" v-show="activeTabId == 2">
                                <div class="right-box-tem">
                                    <div class="right-box-item" v-for="item in customTList" :key="item.id" @click="usePersonalTem(item)">
                                        <div class="right-box-item-imgbox">
                                            <img v-lazy="item.img_url" alt="" />
                                        </div>
                                        <div class="right-box-item-text">
                                            <p>{{ item.name }}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="right-box-pager" v-if="customTPageInfo.total > 0">
                                    <Page
                                        :total="customTPageInfo.total"
                                        :page-size="customTPageInfo.count"
                                        size="small"
                                        @on-change="personalDataByPage"
                                    />
                                </div>
                            </div>

                            <div class="right-box-selected" v-show="activeTabId == 3">
                                <div class="right-box-tem">
                                    <div class="right-box-item" v-for="item in selectedList" :key="item.id" @click="useSelectedTem(item)">
                                        <div class="right-box-item-imgbox">
                                            <img v-lazy="item.pre_img_url" alt="" />
                                        </div>
                                        <div class="right-box-item-text">
                                            <p>{{ item.title }}</p>
                                        </div>
                                        <div class="right-box-item-tag" v-if="item.member_free">
                                            <span>{{ $t(vipTag) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="right-box-lv2" v-show="showLv2List">
                                <div v-for="item in lv2List" :key="item.info.id">
                                    <div class="right-box-lv2-title">
                                        <p class="right-box-title">
                                            {{ lang == "en" ? item.info.name : item.info["name_" + lang] }}
                                        </p>
                                        <p class="tomore" @click="clickLv2(item)">{{ $t("more") }}</p>
                                    </div>
                                    <div class="right-box-tem">
                                        <div
                                            class="right-box-item"
                                            v-for="tem in item.info.templates.slice(0, 3)"
                                            :key="tem.id"
                                            @click="useTemplate(tem)"
                                        >
                                            <div class="right-box-item-imgbox">
                                                <img v-lazy="tem.img_url" alt="" />
                                            </div>
                                            <div class="right-box-item-text">
                                                <p>{{ tem.name }}</p>
                                            </div>
                                            <div class="right-box-item-tag" v-if="tem.type === 'mfree'">
                                                <span>{{ $t(vipTag) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="right-box-template" v-show="showLv2Full">
                                <div v-for="item in templateList" :key="item.info.id">
                                    <p class="right-box-title right-box-template-title">
                                        {{ lang == "en" ? item.info.name : item.info["name_" + lang] }}
                                    </p>
                                    <div class="right-box-tem">
                                        <div class="right-box-item" v-for="tem in item.data" :key="tem.id" @click="useTemplate(tem)">
                                            <div class="right-box-item-imgbox">
                                                <img v-lazy="tem.img_url" alt="" />
                                            </div>
                                            <div class="right-box-item-text">
                                                <p>{{ tem.name }}</p>
                                            </div>
                                            <div class="right-box-item-tag" v-if="tem.type === 'mfree'">
                                                <span>{{ $t(vipTag) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </ScrollView>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import cloneDeep from "lodash/cloneDeep";
    import homeStore from "@/home/store";
    import appConfig from "@/public/config.json";
    import Dialog from "@/app/components/Modals/Dialog.vue";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import collapseTransition from "@/public/utils/collapse-transition.js";
    import { safeEncodeURIComponent } from "@/public/utils/tool.js";

    @Component({
        components: {
            Dialog,
            ScrollView,
            collapseTransition,
        },
    })
    export default class MoreTemplateModal extends Vue {
        @Prop({ default: false }) readonly value!: boolean;
        @Prop() searchVal: string;
        @Prop() readonly showLv2Id: number | string;

        toTemplates() {
            if (this.internal) {
                window.open("https://www.edrawmax.cn/templates/");
                return;
            }
            let langStr = this.lang || appConfig.language;
            let url = `${window.location.origin}${process.env.NODE_ENV === "production" ? "/online" : ""}/${langStr}/store`;
            window.open(url, "_blank");
        }

        get userInfo() {
            return this.$store.state.user ? this.$store.state.user.userInfo : homeStore.state.userInfo;
        }
        get isAd() {
            return homeStore.state.isAd;
        }

        useTemp(item) {
            // if (item.type !== "free" && !this.$checkAuth({ type: "mfree", buyTrigger: "vipTemplate" }, "buyframe")) return;
            let isSliderFreeTemplate = [3417, 3418, 3587, 2860].includes(item.id) && item.type === "free";
            let vipStr = "";
            if (item.type === "mfree") {
                vipStr = "vipTemplate";
            } else if (isSliderFreeTemplate) {
                vipStr = "sliderFreeTemplate";
            }
            this.$edApi
                .getEdrawTemplate({ tpl_id: item.id })
                .then((e) => {
                    let url = e.msg + "/" + safeEncodeURIComponent(e.data[0].url);
                    return this.$edApi.downloadConvertFile({ url: url });
                })
                .then((data: any) => {
                    this.$store.commit("setStatus", {
                        type: "showLibrary",
                        data: true,
                    });
                    window["_view"].openFromTemplate(data.data, vipStr);
                    this.closeModal();
                })
                .catch((err) => {
                    console.log("err", err);
                    (<any>window).testErr = err;
                    (<any>this).$edMessage.warning(this.$t("downloadFail"));
                });
        }

        addTemplateRecent(id) {
            if (this.isPlugin) return;
            if (!this.$validateLogin()) return;
            this.$edApi.addTemplateHistory({
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                data: {
                    template_id: id,
                    template_from: "TEMPLATE",
                },
            });
        }
        async insertTemplateJustDownload(obj, isVip = false) {
            let res = await this.$edApi.downloadOSSFile({
                url: obj.path,
                sign: obj.sign || obj.query,
                exp: obj.exp,
                responseType: "blob",
            });
            if (!res.data) {
                (<any>this).$edMessage.warning(this.$t("downloadFail"));
            } else {
                window["_view"].openFromTemplate(res.data, isVip ? "community" : "");
            }
            this.closeModal();
        }

        closeModal() {
            (<any>this).$emit("close");
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.$bus.$emit("closeMoreTemplate");
        }

        showEmptyView = false;
        get emptyViewText() {
            if (!["zh", "en"].includes(this.lang)) {
                return "";
            }
            if ([1, 2].includes(this.activeTabId) && !this.searchMode) {
                return "null-template";
            } else if (this.searchMode) {
                return "null-search";
            }
        }
        tabList = [
            {
                id: 0,
                label: "recommend",
            },
            {
                id: 1,
                label: "recent",
            },
            {
                id: 2,
                label: "personal",
            },
            {
                id: 3,
                label: "selected",
            },
        ];
        get activeTab() {
            return this.activeTabId > -1 ? this.tabList[this.activeTabId].label : "";
        }
        activeTabId = -1;
        clickTab(id) {
            this.activeMenuChildId = -1;
            this.showLv2List = false;
            this.searchMode = false;
            this.showEmptyView = false;
            this.activeTabId = id;
            switch (id) {
                case 0: {
                    this.getRecommendData([]);
                    break;
                }
                case 1: {
                    this.getRecentData();
                    break;
                }
                case 2: {
                    this.initPersonalPage();
                    this.getPersonalData();
                    break;
                }
                case 3: {
                    this.getSelectedData();
                    break;
                }
            }
            this.resetScrollPosition();
        }
        resetScrollPosition() {
            (this.$refs.rightList as any)?.setScrollY(0);
        }

        get notLogin() {
            return !(this.userInfo && Object.keys(this.userInfo).length > 0);
        }
        recommendTempList = [];
        getRecommendTemplates(obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ pre_tpl_ids: obj.pre_tpl_ids }, this.$store.getters.apiParam);
                this.$edApi
                    .getRecommendTemplates(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        getRecommendTemplatesNotLogin(obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ pre_tpl_ids: obj.pre_tpl_ids });
                this.$edApi
                    .getRecommendTemplatesNotLogin(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        getRecommendData(pre_tpl_ids = []) {
            const dispatchActionName = this.notLogin ? "getRecommendTemplatesNotLogin" : "getRecommendTemplates";

            this[dispatchActionName]({ pre_tpl_ids })
                .then((res: any) => {
                    if (res.data.data.list.length == 0) {
                        return;
                    }
                    const list = res.data.data.list;
                    list.forEach((v) => {
                        v.pre_img_url = window["GLOBAL"].PUBLIC_OSS_HOST + safeEncodeURIComponent(v.img_url);
                    });
                    this.recommendTempList = list;
                })
                .catch(() => {});
        }
        useRecommendTem(item) {
            this.useTemp(item);
            this.addRecent(item);
        }

        // 最近使用
        recentData = [];
        addRecent(item) {
            let index = this.recentData.findIndex((target) => target.id == item.id);
            if (index > -1) {
                const item = this.recentData.splice(index, 1)[0];
                this.recentData.unshift(item);
            } else {
                this.recentData.push(item);
            }
            this.setRecentData();
        }
        getRecentData() {
            if (this.notLogin) return;
            let localData = localStorage.getItem("MoreTemplateRecent");
            if (localData) {
                let obj = JSON.parse(localData) || {};
                this.recentData = obj[this.userInfo.user_id] || [];
                if (this.recentData.length == 0 && this.activeTabId == 1) {
                    this.showEmptyView = true;
                }
            } else {
                this.activeTabId == 1 && (this.showEmptyView = true);
            }
        }
        setRecentData() {
            let localData = localStorage.getItem("MoreTemplateRecent");
            let obj;
            if (localData) {
                obj = JSON.parse(localData) || {};
            } else {
                obj = {};
            }
            obj[this.userInfo.user_id] = this.recentData;
            localStorage.setItem("MoreTemplateRecent", JSON.stringify(obj));
        }
        useRecentTem(item) {
            this.useTemp(item);
            this.addRecent(item);
        }

        // 个人模板相关
        customLoaded = false;
        customTPageInfo = {
            total: 0,
            count: 20,
            offset: 0,
            currentPage: 1,
        };
        customTList = [];
        initPersonalPage() {
            this.customTPageInfo = {
                total: 0,
                count: 20,
                offset: 0,
                currentPage: 1,
            };
        }
        getPersonalData() {
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (this.customTPageInfo.currentPage - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customLoaded = true;
                this.customTList = e.data || [];
                this.customTPageInfo.total = e.msg - 0;
                if (this.customTList.length == 0 && this.activeTabId == 2) {
                    this.showEmptyView = true;
                }
                console.log(this.customTList);
            });
        }
        personalDataByPage(page) {
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (page - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customTPageInfo.currentPage = page;
                this.customTList = e.data;
                this.customTPageInfo.total = e.msg - 0;
                this.resetScrollPosition();
            });
        }
        usePersonalTem(item) {
            this.$edApi
                .downloadCustomTemplate({
                    user_id: this.userInfo.user_id,
                    data: {
                        platform: "web",
                        template_id: item.id,
                        token: this.userInfo.token,
                    },
                })
                .then((res) => {
                    this.insertTemplateJustDownload(res);
                });
        }

        // 社区精选
        selectedList = [];
        getSelectedData() {
            this.$edApi.getFeatured().then((e) => {
                let list = e.data.data;
                list.forEach((item) => {
                    item["pre_img_url"] = `${window["GLOBAL"].PUBLIC_OSS_HOST}${item.url}thumb.png`;
                    return item;
                });
                this.selectedList = list;
            });
        }
        useSelectedTem(item) {
            this.$edApi.getTemplateSign({ tid: item.id }).then((res) => {
                let url = res.data.data.url;
                this.$edApi.downloadConvertFile({ url }).then((res) => {
                    if (!res.data) {
                        (<any>this).$edMessage.warning(this.$t("downloadFail"));
                    } else {
                        window["_view"].openFromTemplate(res.data, item.member_free == 1 ? "community" : "");
                    }
                    this.closeModal();
                });
            });
            // this.insertTemplateJustDownload(item, item.member_free == 1);
            // this.addRecent(item);
        }

        menuList = [];
        initList() {
            this.$edApi.getMoreTemplateList().then((res) => {
                let list = res.data.data; // JSON.parse(JSON.stringify(this.templates));
                this.menuList = list;

                // SEO链接，定位到对应的模板
                const lv2Id = Number(this.showLv2Id);
                if (lv2Id > 0 && this.menuList.length > 0) {
                    for (let i = 0; i < this.menuList.length; i++) {
                        const lv2Arr = this.menuList[i].lv2 || [];
                        for (let j = 0; j < lv2Arr.length; j++) {
                            const lv2 = lv2Arr[j];
                            if (lv2?.info?.id === lv2Id) {
                                this.clickMenu(this.menuList[i]);
                                this.clickLv2(lv2);
                                return;
                            }
                        }
                    }
                }
            });
        }
        activeMenuId = -1;
        expandMenuId = -1;
        showLv2List = false;
        lv2List = [];
        clickMenu(item) {
            this.searchMode = false;
            this.showEmptyView = false;
            let id = item.info.id;
            this.activeTabId = -1;
            this.activeMenuId = id;
            if (id == this.expandMenuId) {
                this.expandMenuId = -1;
                this.activeMenuId = -1;
                this.activeMenuChildId = -1;
                this.showLv2List = true;
            } else {
                this.activeMenuChildId = -1;
                this.expandMenuId = id;
                this.showLv2List = true;
                let lv2 = JSON.parse(JSON.stringify(item.lv2));
                this.lv2List = lv2.map((item) => {
                    let list = item.info.templates;
                    list.forEach((element) => {
                        element.img_url = window["GLOBAL"].PUBLIC_OSS_HOST + safeEncodeURIComponent(element.img_url);
                    });
                    return item;
                });
            }
            this.resetScrollPosition();
        }
        templateList = [];
        activeMenuChildId = -1;
        get showLv2Full() {
            return this.activeMenuChildId != -1 && this.templateList.length > 0;
        }
        async clickLv2(child) {
            console.log(child);
            this.searchMode = false;
            this.showEmptyView = false;
            this.activeTabId = -1;
            this.activeMenuId = -1;
            this.showLv2List = false;
            this.activeMenuChildId = child.info.id;
            this.expandParent(child.info.id);
            let lv3 = child.lv3;
            let list = [];
            let dataList = await this.getLv3Template(child.info.id);
            if (dataList instanceof Array && dataList.length > 0) {
                dataList.forEach((item) => {
                    item.img_url = window["GLOBAL"].PUBLIC_OSS_HOST + safeEncodeURIComponent(item.img_url);
                    return item;
                });
                for (let i = 0; i < lv3.length; i++) {
                    let item = lv3[i];
                    list.push({
                        info: item,
                        data: dataList.filter((dataItem) => dataItem.sub_class_id == item.id),
                    });
                }
            }
            this.templateList = list;
            this.resetScrollPosition();
        }
        expandParent(lv2Id) {
            for (let i = 0; i < this.menuList.length; i++) {
                let lv2 = this.menuList[i].lv2;
                for (let j = 0; j < lv2.length; j++) {
                    if (lv2[j].info.id == lv2Id) {
                        this.expandMenuId = this.menuList[i].info.id;
                        return;
                    }
                }
            }
        }
        async getLv3Template(id) {
            let res = await this.$edApi.getMoreTemplate({ class_id: id });
            return res.data.data;
        }
        useTemplate(item) {
            this.useTemp(item);
            this.addRecent(item);
        }

        // 搜索
        searchValue = "";
        searchMode = false;
        searchList = [];
        search() {
            if (this.searchValue.trim() == "") return;
            this.searchList = [];
            this.searchMode = true;
            this.showEmptyView = false;
            this.$edApi
                .searchTem({
                    name: this.searchValue.trim(),
                    offset: 0,
                    count: 9999,
                    lang: this.lang,
                })
                .then((res) => {
                    if (res.data.data.length == 0 && this.searchMode) {
                        this.showEmptyView = true;
                    }
                    this.sensors.track("searchTemplate", {
                        Catalogues: "RecommendedTemplate",
                        searchterm: this.searchValue,
                        search_source: "popup",
                    });
                    if (res.data.data.length == 0 && this.lang === "zh") {
                        this.sensors.track("searchDiagramResult", {
                            Catalogues: "searchDiagram",
                            is_find_diagram_type: "no",
                            is_find_template: "no",
                        });
                        return;
                    }
                    this.sensors.track("searchDiagramResult", {
                        Catalogues: "searchDiagram",
                        is_find_diagram_type: "no",
                        is_find_template: "yes",
                    });
                    let templates = cloneDeep(res.data.data);

                    templates.forEach((element) => {
                        element.img_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${safeEncodeURIComponent(element.img_url)}`;
                    });
                    this.searchList = templates;
                });
        }
        backFromSearch() {
            this.searchMode = false;
            this.searchList = [];
        }
        useSearchTem(item) {
            this.useTemp(item);
            this.addRecent(item);
        }

        autoOpen = false;
        getOpenStatus() {
            let localData = localStorage.getItem("autoOpenMoreTemplate");
            this.autoOpen = ["0", "1"].includes(localData) ? localData == "1" : true;
        }
        setOpenStatus() {
            localStorage.setItem("autoOpenMoreTemplate", this.autoOpen ? "1" : "0");
        }
        escClose(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }
        get vipTag() {
            if (this.vip) {
                return "vipTag";
            } else {
                return "vipTry";
            }
        }

        mounted() {
            this.getOpenStatus();
            this.clickTab(0);
            this.initList();
            this.getRecentData();
            window.addEventListener("keydown", this.escClose);
            if (this.searchVal) {
                this.searchValue = this.searchVal;
                this.search();
            }
        }

        beforeDestroy() {
            window.removeEventListener("keydown", this.escClose);
        }
    }
</script>

<style scoped lang="stylus">
        /deep/.ivu-modal-mask
            z-index 1000 !important
        /deep/.ivu-modal-wrap
            z-index 1000 !important
        /deep/.ivu-modal-wrap
           .ivu-modal-header
                padding 8px 24px
                border-bottom 1px solid rgba(0, 0, 0, 0.08)
            .ivu-icon-ios-close
                top: 8px
            .ivu-modal-body
                padding 0
        /deep/.ivu-modal-content
             height 600px

        /deep/.ivu-input-wrapper .ivu-input-icon-clear
                display: inline-block


        .text-ellipsis
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
        .more-template-modal
            .modal-header
                display flex
                align-items center
                justify-content space-between
                .title
                    font-size 14px
                    font-weight 700
                    color #222
                    line-height 18px
                .title-search
                    margin-left 120px
                    width 320px
                    height 32px

                    /deep/.ivu-input-default
                        outline none
                        &:hover,&:focus
                            outline none
                            border 1px solid var(--themeColor)
                            border-color var(--themeColor)
                            box-shadow unset !important

                /deep/.ivu-input
                    border-radius 6px
                /deep/.ivu-input-prefix
                        width 14.5px
                        height 14.5px
                        left 9px
                        top 0
                        bottom 0
                        margin auto

                        .search-inputicon
                            width 14.5px
                            height 14.5px
                            cursor pointer
                            color var(--text-color-tertiary)
                            opacity: 0.4;
                /deep/.ivu-icon-ios-close-circle
                    &::before
                        content ''
                    &::after
                        content url('~@/home/assets/img/newPage/recommend/clear.svg')
                        display block
                        margin-top 4px
            .header-left
                display flex
                align-items center
            .close-icon
                border-radius 6px
                display flex
                align-items center
                justify-content center
                width 24px
                height 24px
                padding 6px
                cursor pointer
                border-radius 6px
                &:hover
                    background rgba(0,0,0,0.06)


            .modal-content
                display: flex
                position relative
                height 549px
            .side-bar
                width 176px
                height 100%
                display flex
                flex-direction column
                justify-content space-between
                padding 16px
                border-right 1px solid rgba(0, 0, 0, 0.08)
                .nav-list
                    width 144px
                    .nav-item
                        margin 2px 0px
                        height 40px
                        line-height 40px
                        color #222
                        padding 0 16px
                        cursor pointer
                        font-size 14px
                        &:hover,&.active
                            border-radius 6px
                            background var(--theme-color-8)
                            color var(--themeColor)
                    .line
                        border-bottom 1px solid rgba(0,0,0,0.05)
                        margin 8px 0

                .templates
                    border-radius 6px
                    border 1px solid rgba(0, 0, 0, 0.08)
                    display flex
                    align-items center
                    padding 0px 28px
                    color var(--themeColor)
                    cursor pointer
                    height 40px
                    line-height 40px
                    &:hover
                        border-color var(--themeColor)
                    img
                        margin-right 4px
            .template-content
                max-height 100%
                // overflow scroll
                padding 16px 0px 16px 24px
                width 100%
                overflow overlay
                margin-bottom 8px
                position relative
                .search-num
                    margin-bottom 16px
                    .search-value
                        color var(--themeColor)
                .template-list
                    display flex
                    flex-wrap wrap
                    &::-webkit-scrollbar
                        width 6px
                        background-color rgba(0,0,0,0.15)
                        border-radius 8px
                    .template-item
                        width 198px
                        margin-right 24px
                        margin-bottom 24px
                        border-radius 8px
                        border 1px solid rgba(0, 0, 0, 0.08)
                        cursor pointer
                        position relative
                        &:nth-child(3n)
                            margin-right 0
                        .img
                            padding 8px
                            border-bottom 1px solid rgba(0, 0, 0, 0.08)
                            display flex
                            justify-content center
                            width 196px
                            height 132px
                            position relative
                            .card-ai-tag
                                position absolute
                                height 14px
                                width 28px
                                bottom 20px
                                right 32px
                            img
                                max-height 100%
                                max-width 100%
                                object-fit contain
                        .img-mask
                            position absolute
                            top 0
                            right 0
                            bottom 0
                            left 0
                            margin auto
                            border-radius 8px
                            background rgba(0, 0, 0, 0.40)
                            display none
                            .use-btn
                                position absolute
                                top 0
                                right 0
                                bottom 0
                                left 0
                                margin auto
                                height 32px
                                line-height 32px
                                width 100px
                                text-align center
                                border-radius 4px
                                background var(--themeColor)
                                font-size 12px
                                color #fff
                                padding 0 5px
                            .ai-btn
                                width 104px
                                background linear-gradient(0deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.06) 100%), linear-gradient(90deg, #8548FF 0%, #4D53FF 52.6%, #4895FF 100%)
                            .template-tag
                                position absolute
                                left 0
                                top 0
                                background linear-gradient(98deg, #FFEDD1 0%, #FFCF88 100%)
                                width 70px
                                height 24px
                                line-height 24px
                                text-align center
                                border-radius  8px 0 8px 0
                                font-weight 700
                                font-size 14px
                                color #642515



                        &:hover
                            .img-mask
                                display: block
                                border 1px solid var(--themeColor)

                        .text
                            padding 12px 8px
                            font-size 14px
                            color #222
                .search-no-tip
                    width 100%
                    height 100%
                    position relative
                    .search-no-box
                        position absolute
                        top 0
                        right 0
                        bottom 0
                        left 0
                        height 200px
                        margin auto
                        display flex;
                        flex-direction column;
                        align-items center;
                        .tip
                            margin 8px 0 24px
                            color rgba(34, 34, 34, 0.40)
                        .go-store
                            width 138px
                            padding 4px 20px
                            background var(--themeColor)
                            color #fff
                            border-radius  4px
                            cursor pointer
                            &:hover
                                opacity 0.8



            .newpage-loading
                position absolute
                left 0
                right 0
                top 0
                bottom 0
                display flex
                justify-content center
                align-items center
                z-index 10
                pointer-events none
                user-select none
                img
                    width 64px
    .template-modal
        position absolute
        width 986px
        height 720px
        border-radius 8px
        border 1px solid #0000000D
        box-shadow 0px 15px 30px 0px #00000026
        ::v-deep.dialog-slot
            width 100%
            height 100%
            padding 0
        .close-icon
            position absolute
            right 8px
            top 12px
            width 24px
            height 24px
            padding 7px
            cursor pointer
            border-radius 6px
            &:hover
                background rgba(0,0,0,0.06)
            img
                display block
                width 10px
                height 10px
        .template-content
            display flex
            width 100%
            height 100%
            .left-menu
                display flex
                flex-direction column
                width 240px
                height 100%
                flex-shrink 0
                background-repeat no-repeat
                .title-box
                    display flex
                    align-items center
                    column-gap 4px
                    padding 16px 0 16px 24px
                    p
                        font-size 14px
                        line-height 18px
                        font-weight 700
                        color #222
                        textOverflow()
                .tab-list
                    height 198px
                    margin 0 16px 16px 0
                    padding 8px 0 16px 0
                    border-bottom 1px solid var(--border-color-gray1)
                    display flex
                    flex-wrap wrap
                    column-gap 2px
                    .tab-item
                        width 100%
                        height 40px
                        border-radius 6px
                        padding 8px
                        display flex
                        align-items center
                        cursor pointer
                        svg
                            color #222
                            flex-shrink 0
                            width 24px
                            height 24px
                            margin-right 4px
                        p
                            font-size 14px
                            line-height 18px
                            color #222
                        &:hover
                            background var(--theme-color-8)
                        &.active
                            background var(--theme-color-8)
                            p
                                color var(--themeColor)
                            svg
                                color var(--themeColor)


                .leftmenu-list
                    flex-grow 1
                    align-content flex-start
                    margin-left 16px
                    display flex
                    flex-wrap wrap
                    column-gap 2px
                    ::v-deep.xx-scrollbar-view
                        width 100%
                    .leftmenu-item
                        width calc(100% - 16px)
                        margin-right 16px
                        height fit-content
                        padding 0
                        display flex
                        align-items center
                        flex-wrap wrap
                        .leftmenu-item-head
                            display flex
                            align-items center
                            cursor pointer
                            width 100%
                            height 40px
                            border-radius 6px
                            padding 8px
                            svg
                                flex-shrink 0
                                width 24px
                                height 24px
                                margin-right 4px
                                color #222
                            p
                                font-size 14px
                                line-height 18px
                                color #222
                                textOverflow()
                            .leftmenu-arrow
                                margin-left auto
                                width 16px
                                height 16px
                                margin-right 0px
                            &:hover
                                background var(--theme-color-8)
                            &.active
                                background var(--theme-color-8)
                                >p
                                    color var(--themeColor)
                                svg
                                    color var(--themeColor)
                        .leftmenu-item-childlist
                            width 100%
                            margin-top 2px
                            display flex
                            flex-wrap wrap
                            column-gap 2px
                            background #fff
                            .leftmenu-item-child
                                height 40px
                                width 100%
                                border-radius 6px
                                display flex
                                align-items center
                                cursor pointer
                                padding-left 36px
                                margin-bottom 2px
                                p
                                    font-size 14px
                                    color #222
                                    textOverflow()
                                &:hover
                                    background var(--theme-color-8)
                                &.active
                                    background var(--theme-color-8)
                                    >p
                                        color var(--themeColor)
                .checkbox-box
                    display flex
                    align-items center
                    width 100%
                    height 58px
                    flex-shrink 0
                    padding 0 24px
                    ::v-deep.ivu-checkbox
                        margin-right 6px
                        margin-bottom 2px
                    .echartSet_checkbox
                        textOverflow()

            .right-box
                flex 1
                .topbar
                    display flex
                    align-items center
                    height 56px
                    padding-left 24px
                    margin-bottom 16px
                    .title-search
                        width 452px
                        height 32px

                        /deep/.ivu-input-default
                            outline none
                            &:hover,&:focus
                                outline none
                                border 1px solid var(--themeColor)
                                border-color var(--themeColor)
                                box-shadow unset !important

                    /deep/.ivu-input
                        border-radius 6px
                    /deep/.ivu-input-prefix
                        width 14.5px
                        height 14.5px
                        left 9px
                        top 0
                        bottom 0
                        margin auto

                        .search-inputicon
                            width 14.5px
                            height 14.5px
                            cursor pointer
                            color var(--text-color-tertiary)
                            opacity: 0.4;
                .right-box-emptyview
                    width 100%
                    height calc(100% - 80px)
                    display flex
                    flex-direction column
                    justify-content center
                    align-items center
                    p
                        margin-top 8px
                        font-size 14px
                        line-height 18px
                        color #00000080

                .right-box-title
                    font-size 16px
                    line-height 20px
                    font-weight 700
                    color #000
                .right-box-btn
                    display flex
                    align-items center
                    cursor pointer
                    color var(--themeColor)
                    font-size 14px
                    &:hover
                        color var(--themeHover)
                .right-box-topbar
                    display flex
                    justify-content space-between
                    align-items center
                    margin 0 24px
                    margin-bottom 24px
                .right-box-list
                    margin-left 24px
                    height calc(100% - 117px)
                    &.right-box-template-list
                        height calc(100% - 72px)
                    .right-box-template-title
                        margin-bottom 24px
                    .right-box-lv2,.right-box-template
                        .right-box-tem
                            margin-bottom 40px
                    .right-box-lv2-title
                        display flex
                        justify-content space-between
                        margin-bottom 24px
                        margin-right 24px
                        .tomore
                            font-size 14px
                            color var(--themeColor)
                            margin-right 6px
                            cursor pointer
                    .right-box-back
                        display flex
                        align-items center
                        margin-bottom 24px
                        width fit-content
                        cursor pointer
                        img
                            margin-right 4px
                            transform rotate(180deg)
                        p
                            font-size 12px
                            color #222
                    .right-box-tem
                        display flex
                        flex-wrap wrap
                        column-gap 24px
                        row-gap 24px
                        padding-bottom 24px
                        .right-box-item
                            position relative
                            width 216px
                            height 194px
                            border: 1px solid #F2F4F9
                            border-radius 8px
                            background #F2F4F9
                            cursor pointer
                            &:hover
                                border-color var(--themeColor)
                            .right-box-item-imgbox
                                width 100%
                                height 144px
                                padding 8px
                                padding-bottom 0
                                img
                                    display block
                                    width 100%
                                    height 100%
                                    object-fit contain
                                    border-radius 6px
                                    background #fff
                            .right-box-item-text
                                height 48px
                                display flex
                                align-items center
                                padding 0 12px
                                p
                                    width 100%
                                    font-size 14px
                                    line-height 18px
                                    color #222
                                    textOverflow()
                            .right-box-item-tag
                                position absolute
                                left 0
                                top 0
                                background linear-gradient(98deg, #ffedd1, #ffcf88)
                                padding 0 14px
                                height 24px
                                line-height 24px
                                text-align center
                                border-radius: 8px 0 8px 0
                                font-weight 700
                                font-size 12px
                                color #642515
                    .right-box-personal
                        padding-bottom 56px;
                        .right-box-pager
                            position absolute
                            bottom 0
                            height 56px
                            background #fff
                            width 100%
                            display flex
                            justify-content center
                            align-items center
</style>
<i18n>
{
  "zh": {
    "search": "搜索模板",
    "templates": "模板社区",
    "vipTag": "VIP专享",
    "vipTry": "免费试用",
    "clone": "立即使用",
    "aiCreate": "AI一键制图",
    "searchResult": "搜索结果",
    "preset": "模板搜索",
    "noRes": "没有找到相关模板",
    "visitTemplate": "去模板社区看看",
    "allTemplate": "所有模板",
    "downloadFail": "下载文件失败",

    "title": "插入模板",
    "recommend": "推荐模板",
    "recent": "最近使用",
    "personal": "个人模板",
    "selected": "社区精选",
    "autoOpen": "新建空白文档时自动打开",
    "toStore": "前往模板社区查看更多",
    "more": "查看更多",
    "back": "返回",
    "null-template": "当前分类下没有模版",
    "null-search": "当前没有匹配的模版"
  },
  "en": {
    "search": "Search template",
    "templates": "Templates Community",
    "vipTag": "Premiun",
    "vipTry": "Free Trial",
    "clone": "Use immediately",
    "aiCreate": "AI Diagramming",
    "searchResult": "Search result",
    "preset": "Search",
    "noRes": "Sorry, no template found",
    "visitTemplate": "Visit template community",
    "recommendTemplate": "Recommended Templates",
    "allTemplate": "All templates",
    "downloadFail": "Fail to download file",
    "title": "Insert Templates",
    "recommend": "Recommended",
    "recent": "Recent",
    "personal": "Personal Templates",
    "selected": "Community Selection",
    "autoOpen": "Automatically open new files",
    "toStore": "View More Templates",
    "more": "More",
    "back": "Return",
    "null-template": "No templates in this category.",
    "null-search": "No matching templates found."
  },
  "fr": {
    "search": "Rechercher",
    "templates": "Communauté des Modèles",
    "vipTag": "Premium",
    "vipTry": "Essai gratuit",
    "aiCreate": "Création de diagrammes IA",
    "searchResult": "Résultats de la recherche",
    "noRes": "Désolé, aucun modèle trouvé.",
    "allTemplate": "Tous les modèles",
    "visitTemplate": "Visitez la communauté de modèles",
    "clone": "Utiliser immédiatement",
    "downloadFail": "Défaut de télécharger le fichier",
    "title": "Insérer des modèles",
    "recommend": "Recommandé",
    "recent": "Récent",
    "personal": "Modèles personnels",
    "selected": "Sélection de la communauté",
    "autoOpen": "Ouvrir automatiquement les nouveaux fichiers",
    "toStore": "Afficher plus de modèles",
    "more": "Plus",
    "back": "retour",
    "null-template": "Aucun modèle dans cette catégorie.",
    "null-search": "Aucun modèle correspondant."
  },
  "de": {
    "search": "Suchen",
    "templates": "Schablonen Gemeinschaft",
    "vipTag": "Premium",
    "vipTry": "Kostenlose Testversion",
    "aiCreate": "AI Diagramm",
    "searchResult": "Suchergebnis",
    "noRes": "Entschuldigung, keine Vorlage gefunden",
    "allTemplate": "Alle Vorlagen",
    "visitTemplate": "Vorlagen-Community besuchen",
    "clone": "sofort verwenden",
    "downloadFail": "Fehler beim Herunterladen der Datei",
    "title": "Vorlagen einfügen",
    "recommend": "Empfohlen",
    "recent": "Zuletzt",
    "personal": "Persönliche Vorlagen",
    "selected": "Community-Auswahl",
    "autoOpen": "Neue Dateien automatisch öffnen",
    "toStore": "Weitere Vorlagen anzeigen",
    "more": "Mehr",
    "back": "Rückkehr",
    "null-template": "Keine Vorlagen in dieser Kategorie.",
    "null-search": "Keine übereinstimmenden Vorlagen gefunden."
  },
   "jp": {
    "search": "検索",
    "templates": "テンプレートコミュニティ",
    "vipTag": "プレミアム",
    "vipTry": "無料トライアル",
    "aiCreate": "AI作図",
    "searchResult": "検索結果",
    "noRes": "テンプレートが見つかりませんでした",
    "allTemplate": "すべてのテンプレート",
    "visitTemplate": "テンプレートコミュニティで探す",
    "clone": "すぐに使う",
    "downloadFail": "ファイルのダウンロードに失敗しました",
    "title": "テンプレートを挿入",
    "recommend": "おすすめ",
    "recent": "最近",
    "personal": "個人テンプレート",
    "selected": "コミュニティセレクション",
    "autoOpen": "新しいファイルを自動的に開く",
    "toStore": "テンプレートをもっと見る",
    "more": "その他",
    "back": "戻る",
    "null-template": "このカテゴリにはテンプレートがありません。",
    "null-search": "一致するテンプレートが見つかりません。"
  },
  "es": {
    "search": "Buscar",
    "templates": "Comunidad de Plantillas",
    "vipTag": "Premium",
    "vipTry": "Prueba gratuita",
    "aiCreate": "Creación de diagramas de IA",
    "searchResult": "Resultados de búsqueda",
    "noRes": "Lo sentimos, no se encontraron plantillas",
    "allTemplate": "Todas las plantillas",
    "visitTemplate": "Visitar la comunidad de plantillas",
    "clone": "usar inmediatamente",
    "downloadFail": "Si no se descarga el archivo",
    "title": "Insertar plantillas",
    "recommend": "Recomendado",
    "recent": "Reciente",
    "personal": "Plantillas Personales",
    "selected": "Seleccionadas por la comunidad",
    "autoOpen": "Abrir automáticamente los nuevos archivos",
    "toStore": "Ver más plantillas",
    "more": "Más",
    "back": "regreso",
    "null-template": "No hay plantillas en esta categoría.",
    "null-search": "No se han encontrado plantillas coincidentes."
  },
  "it": {
    "search": "Cerca",
    "templates": "Comunità di Modelli",
    "vipTag": "Premium",
    "vipTry": "Versione di prova gratuita",
    "aiCreate": "Applicazione diagramma AI",
    "searchResult": "Risultati della ricerca",
    "noRes": "Non è stato trovato nessun modello.",
    "allTemplate": "Tutti i modelli",
    "visitTemplate": "Visita la community dei modelli",
    "clone": "utilizzare immediatamente",
    "downloadFail": "Impossibile eseguire il download",
    "title": "Inserisci modelli",
    "recommend": "Consigliato",
    "recent": "Recenti",
    "personal": "Modelli Personali",
    "selected": "Selezione della community",
    "autoOpen": "Apri automaticamente i nuovi file",
    "toStore": "Visualizza altri modelli",
    "more": "Altro",
    "back": "ritorno",
    "null-template": "Nessun modello in questa categoria.",
    "null-search": "Non è stato trovato nessun modello corrispondente."
  },
  "pt": {
    "search": "Pesquisar",
    "templates": "Comunidade de Modelos",
    "vipTag": "Premium",
    "vipTry": "Avaliação gratuita",
    "aiCreate": "Diagramação de IA",
    "searchResult": "Resultado da pesquisa",
    "noRes": "Nenhum modelo encontrado",
    "allTemplate": "Todos os modelos",
    "visitTemplate": "Visitar a comunidade de modelos",
    "clone": "usar imediatamente",
    "downloadFail": "Falha ao descarregar o ficheiro",
    "title": "Inserir modelos",
    "recommend": "Recomendado",
    "recent": "Recentes",
    "personal": "Modelos Pessoais",
    "selected": "Seleção de comunidade",
    "autoOpen": "Abrir novos arquivos automaticamente",
    "toStore": "Exibir mais modelos",
    "more": "Mais",
    "back": "Retorna",
    "null-template": "Nenhum modelo nesta categoria.",
    "null-search": "Nenhum modelo correspondente encontrado."
  },
  "tw": {
    "search": "搜尋",
    "templates": "範本社區",
    "vipTag": "Premium",
    "vipTry": "免費試用",
    "aiCreate": "AI 製圖",
    "searchResult": "搜尋結果",
    "noRes": "抱歉，找不到範本",
    "allTemplate": "所有範本",
    "visitTemplate": "造訪範本社群",
    "clone": "立即使用",
    "downloadFail": "下載檔案失敗",
    "title": "插入模板",
    "recommend": "推荐模板",
    "recent": "最近使用",
    "personal": "个人模板",
    "selected": "社区精选",
    "autoOpen": "自動開啟新檔案",
    "toStore": "檢視更多範本",
    "more": "查看更多",
    "back": "返回",
    "null-template": "当前分类下没有模版",
    "null-search": "当前没有匹配的模版"
  },
  "kr": {
    "search": "검색",
    "templates": "템플릿 갤러리",
    "vipTag": "회원무료",
    "vipTry": "무료 평가판",
    "clone": "바로 사용하기",
    "searchResult": "검색 결과",
    "noRes": "죄송합니다. 템플릿을 찾을 수 없습니다.",
    "allTemplate": "모든 템플릿",
    "visitTemplate": "템플릿 커뮤니티 방문",
    "clone": "그리기 시작하다",
    "downloadFail": "파일을 다운로드하지 못했습니다",
    "title": "템플릿 삽입",
    "recommend": "추천",
    "recent": "최근",
    "personal": "개인 템플릿",
    "selected": "커뮤니티 선택",
    "autoOpen": "자동으로 새 파일 열기",
    "toStore": "템플릿 더 보기",
    "more": "更多",
    "back": "돌아가기",
    "null-template": "当前分类下没有模版",
    "null-search": "当前没有匹配的模版"
  },
  "id": {
    "search": "Cari templat",
    "templates": "Komunitas Templat",
    "vipTag": "VIP Gratis",
    "vipTry": "Free Trial",
    "clone": "Gunakan segera",
    "searchResult": "searchResult",
    "noRes": "Maaf, templat tidak ditemukan",
    "title": "Sisipkan Templat",
    "recommend": "Rekomendasi",
    "recent": "Terbaru",
    "personal": "Templat Pribadi",
    "selected": "Pilihan Komunitas",
    "autoOpen": "新建空白文档时自动打开",
    "toStore": "前往模板社区查看更多",
    "more": "查看更多",
    "back": "Kembali",
    "null-template": "当前分类下没有模版",
    "null-search": "当前没有匹配的模版"
  }
}
</i18n>
